import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const Thongkephuongtien = React.memo(function Thongkephuongtien(props) {
  const classes = useStyles();
  const { phuongtien } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebcsotandan_th}>
            Phương tiện cơ giới đường bộ
          </th>
          <th className={classes.tablebcsotandan_th}>
            Số lượng xe đăng ký kinh doanh
          </th>
          <th className={classes.tablebcsotandan_th}>
            Số lượng xe không đăng ký kinh doanh
          </th>
          <th className={classes.tablebcsotandan_th}>Tổng số lượng</th>
          <th className={classes.tablebcsotandan_th}>Ghi chú</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td_dn}>Xe con</td>
          <td className={classes.tablebc_td_dn}>{phuongtien[0].xecon_kd}</td>
          <td className={classes.tablebc_td_dn}>{phuongtien[0].xecon}</td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xecon + phuongtien[0].xecon_kd}
          </td>
          <td className={classes.tablebc_td_dn}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Xe khách</td>
          <td className={classes.tablebc_td_dn}>{phuongtien[0].xekhach_kd}</td>
          <td className={classes.tablebc_td_dn}>{phuongtien[0].xekhach}</td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xekhach + phuongtien[0].xekhach_kd}
          </td>
          <td className={classes.tablebc_td_dn}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>- Từ 10 đến 25 chỗ</td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xekhach_10_25_kd}
          </td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xekhach_10_25}
          </td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xekhach_10_25_kd + phuongtien[0].xekhach_10_25}
          </td>
          <td className={classes.tablebc_td_dn}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>- Từ 26 đến 46 chỗ</td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xekhach_26_46_kd}
          </td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xekhach_26_46}
          </td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xekhach_26_46_kd + phuongtien[0].xekhach_26_46}
          </td>
          <td className={classes.tablebc_td_dn}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>- Trên 46 chỗ</td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xekhach_tren46_kd}
          </td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xekhach_tren46}
          </td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xekhach_tren46_kd + phuongtien[0].xekhach_tren46}
          </td>
          <td className={classes.tablebc_td_dn}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Xe tải</td>
          <td className={classes.tablebc_td_dn}>{phuongtien[0].xetai_kd}</td>
          <td className={classes.tablebc_td_dn}>{phuongtien[0].xetai}</td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xetai_kd + phuongtien[0].xetai}
          </td>
          <td className={classes.tablebc_td_dn}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>- Tải trọng đến 2 tấn</td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xetai_den2_kd}
          </td>
          <td className={classes.tablebc_td_dn}>{phuongtien[0].xetai_den2}</td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xetai_den2_kd + phuongtien[0].xetai_den2}
          </td>
          <td className={classes.tablebc_td_dn}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>
            - Tải trọng từ trên 2 tấn đến 7 tấn
          </td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xetai_2_7_kd}
          </td>
          <td className={classes.tablebc_td_dn}>{phuongtien[0].xetai_2_7}</td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xetai_2_7_kd + phuongtien[0].xetai_2_7}
          </td>
          <td className={classes.tablebc_td_dn}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>
            - Tải trọng từ trên 7 tấn đến 20 tấn
          </td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xetai_7_20_kd}
          </td>
          <td className={classes.tablebc_td_dn}>{phuongtien[0].xetai_7_20}</td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xetai_7_20_kd + phuongtien[0].xetai_7_20}
          </td>
          <td className={classes.tablebc_td_dn}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>
            - Tải trọng trên 20 tấn, xe đầu kéo
          </td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xetai_tren20_kd}
          </td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xetai_tren20}
          </td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xetai_tren20_kd + phuongtien[0].xetai_tren20}
          </td>
          <td className={classes.tablebc_td_dn}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Xe chuyên dụng và xe khác</td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xechuyendung_kd}
          </td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xechuyendung}
          </td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].xechuyendung_kd + phuongtien[0].xechuyendung}
          </td>
          <td className={classes.tablebc_td_dn}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>- Sơ mi rơ moóc</td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].somiromooc_kd}
          </td>
          <td className={classes.tablebc_td_dn}>{phuongtien[0].somiromooc}</td>
          <td className={classes.tablebc_td_dn}>
            {phuongtien[0].somiromooc_kd + phuongtien[0].somiromooc}
          </td>
          <td className={classes.tablebc_td_dn}></td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = phuongtien.length > 0 ? renderTableBody() : null;
  return (
    <div className={classes.table}>
      <table id="baocaophuongtiencogioi" className={classes.tablebcsotandan}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

Thongkephuongtien.propTypes = {
  phuongtien: PropTypes.array,
};
export default Thongkephuongtien;
